_ = require('lodash')
moment = require('moment')
$ = require('jquery')
ZeroClipboard = require('../../../../ngapp/external-scripts/zero-clipboard/ZeroClipboard')

GroupListCtrl = ($scope ,$location ,$filter ,groupRegisDataService ,formCopyService ,userInfo ,$ngConfirm) ->
  #default Value
  angular.element(document.body).css 'min-width', 0
  copyCommandSupported = document.queryCommandSupported('copy')

  $(document).ready( ->
    document.body.scrollTop = document.documentElement.scrollTop = 0
    if !copyCommandSupported
      ZeroClipboard.config( { swfPath: require('../../../../ngapp/external-scripts/zero-clipboard/ZeroClipboard.swf')})
      $scope.client = new ZeroClipboard($('#btnCopy'))
      $scope.client.clip($('.btn-Copy'))
  )

  pageSize = 4
  $scope.groups = []
  $scope.currentPage = 0
  $scope.isLoading = true
  $scope.noResults = false
  $scope.keyword   = ""
  $scope.isAdmin   = userInfo.admin

  $scope.loadMore = ->
    $scope.isLoading = true
    $scope.currentPage++
    groupRegisDataService.searchGroup($scope.keyword ,$scope.currentPage , pageSize )
      .then (data) ->
        $scope.groups = _.union($scope.groups , data.groups)
        $scope.totalPages = data.total_pages
        $scope.noResults = $scope.groups.length is 0
      .finally ->
        $scope.isLoading = false

  $scope.editGroup = ( id ,event ) ->
    if event.stopPropagation
      event.stopPropagation()
    $location.path('/groups/' + id + '/edit')

  $scope.hasMore = ->
    $scope.noResults == false && $scope.currentPage isnt $scope.totalPages

  $scope.displayPrivacy = (privacy) ->
    if privacy
    then $filter('translate')('_GROUP.LIST.PUBLIC_GROUP')
    else $filter('translate')('_GROUP.LIST.PRIVATE_GROUP')

  $scope.displayMember = (member) ->
    ($filter('translate')('_GROUP.LIST.MEMBERS')) + ': ' + member + ($filter('translate')('_GROUP.LIST.MEMBERS_EXT'))

  $scope.searchGroup = (keyTemp)->
    keyTemp = keyTemp ? ''
    $location.url("/groups/search?key=#{keyTemp}")

  $scope.dataURL = (id) ->
    $location.absUrl() + '/join?id=' + id

  $scope.copyFunc = ( id ,event ) ->
    if event.stopPropagation
      event.stopPropagation()

    if !copyCommandSupported
      $scope.client.emit()
    else
      formCopyService.copy($scope.dataURL(id))
    mess = $filter('translate')('_GROUP.TOOLBAR.COPY_MESS_URL')
    $ngConfirm(mess)

  $scope.goCreatePage = ->
    $location.path('/groups/registration')

  $scope.gotoGroup = (id , event) ->
    if event.stopPropagation
      event.stopPropagation()
    $location.path('/groups/'+id)

  $scope.goToListRequest = (id , event) ->
    if event.stopPropagation
      event.stopPropagation()
    $location.path("/groups/#{id}/members/list-request")

  $scope.$watch('groups' , () ->
    if copyCommandSupported
      return
    setTimeout(() ->
      $scope.client.clip($('.btn-Copy'))
    , 0)
  ,true)

  $scope.loadMore()

  #destroy page
  $scope.$on '$destroy', ->
    ZeroClipboard.destroy()

GroupListCtrl.$inject = [
  '$scope'
  '$location'
  '$filter'
  'groupRegisDataService'
  'formCopyService'
  'userInfo'
  '$ngConfirm'
]

module.exports = GroupListCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/groups/group-list-controller.coffee